import { render, staticRenderFns } from "./InputAddress.vue?vue&type=template&id=06f423a4&scoped=true&"
import script from "./InputAddress.vue?vue&type=script&lang=js&"
export * from "./InputAddress.vue?vue&type=script&lang=js&"
import style0 from "./InputAddress.vue?vue&type=style&index=0&id=06f423a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f423a4",
  null
  
)

export default component.exports